module.exports = __webpack_public_path__ + "img/vcard-exchange-success.d9c72123.svg";